// extracted by mini-css-extract-plugin
module.exports = {"switch_container":"toggle-switch_switch_container__1ikio","active":"toggle-switch_active__28xU0","switch_toggler":"toggle-switch_switch_toggler__1qpae"};